<template>
  <section class="event-section" :class="classObject">
    <div class="container">
      <div class="event-content">
        <SectionHeader
          :title="data.title"
          :subcaption="data.permissions"
          :description="data.description"
        />
        <CoolLightBox
          :items="this.data.imagelist ? this.data.imagelist : []"
          :index="index"
          :effect="'fade'"
          :useZoomBar="true"
          @close="index = null"
        >
        </CoolLightBox>
        <div data-aos="fade-up" data-aos-duration="1000" class="image-content">
          <div class="img-wrap" @click="index = 0">
            <div class="hover-bg">
              <div class="hover-text">
                Click to Zoom
              </div>
            </div>
            <img :src="data.image" :alt="image" />
          </div>
          <img class="laptop" src="@/assets/images/laptop.png" alt="laptop" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
export default {
  props: {
    data: {
      type: Object
    },
    extraClass: {
      type: [String, Array]
    }
  },
  components: {
    SectionHeader
  },
  data() {
    return {
      title: this.data.title,
      description: this.data.description ? this.data.description : "",
      image: this.data.image,
      imagelist: this.data.imagelist ? this.data.imagelist : [],
      index: null
    };
  },
  computed: {
    classObject() {
      return this.extraClass ? this.extraClass : "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.event-section {
  .event-content {
    .image-content {
      position: relative;
      .img-wrap {
        position: relative;
        width: 70%;
        max-width: 700px;
        height: 400px;
        margin: 0 auto;
        border-radius: 10px;
        border: 15px solid #3e3e3e;
        border-bottom-width: 10px;
        background: #21216480;
        position: relative;
        cursor: zoom-in;
        @include boxShadow(0, 0px, 20px, 1px, rgba(0, 0, 0, 0.1));
        .hover-bg {
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1;
          opacity: 0;
          background: rgba(0, 0, 0, 0.4);
          @include customTransition(0.3s, cubic-bezier(0.44, 0.9, 1, 1));
          .hover-text {
            font-family: $content-font;
            font-weight: 600;
            text-align: center;
            color: #ffffff;
            font-size: 28px;
          }
        }
        &:hover {
          .hover-bg {
            opacity: 1;
          }
        }
      }
      .laptop {
        max-width: 800px;
        position: absolute;
        bottom: -8;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        width: 100%;
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .event-section {
    .event-content {
      .image-content {
        .img-wrap {
          height: 300px;
        }
        .laptop {
          width: 80%;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .event-section {
    .event-content {
      .image-content {
        .img-wrap {
          height: 250px;
          border-width: 10px;
        }
        .laptop {
          width: 90%;
        }
      }
    }
  }
}

@media only screen and (max-width: 475px) {
  .event-section {
    .event-content {
      .image-content {
        .img-wrap {
          border-width: 8px;
          width: 80%;
          height: 100%;
        }
      }
    }
  }
}
</style>
